<template>
  <div class="page block">
    <div class="page__wrapper block-wrapper">
      <div class="page__header">
        <div class="page__title">
          <Title>{{$t($route.meta.title)}}</Title>
        </div>
      </div>
      <div class="page__body">
        <ServicingInfo/>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/titles/Title'
import ServicingInfo from '@/components/servicing-info/ServicingInfo'
import ServicingController from './servicing-controller'

import {VIEWS} from '@/views/names'

export default {
  name: VIEWS.servicing.name,
  mixins: [ServicingController],
  components: {
    Title,
    ServicingInfo
  }
}
</script>
